import React, {Fragment} from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";

import {addUserFollowing, removeUserFollowing, resetUserFollowing} from "../../../../creators/user.following";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAngleDoubleRight} from "@fortawesome/free-solid-svg-icons";
import {SpinLoader} from "../../../components/Loader";
import classNames from "classnames";

class ProfileFollows extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isFollow: this.props.isFollow || false,
        };
        this.handleFollow = this.handleFollow.bind(this);
    }

    componentWillUnmount() {
        this.props.resetUserFollowing();
    }

    componentDidUpdate(prevProps) {
        if(prevProps.isFollow !== this.props.isFollow){
            this.setState({isFollow: this.props.isFollow});
        }
        if ((prevProps.userFollowingError.error !== this.props.userFollowingError.error) && this.props.userFollowingError.error !== null) {
            this.setState({isFollow: !this.state.isFollow});
        }
    }

    handleFollow() {
        if (this.state.isFollow) {
            this.props.removeUserFollowing(this.props.currentUserId, this.props.userId);
            this.setState({isFollow: false});
        } else {
            this.props.addUserFollowing(this.props.currentUserId, this.props.userId);
            this.setState({isFollow: true});
        }
    }

    render() {
        return (
            <div className={classNames("btn-profile-subnav", {"primary-reverse": !this.state.isFollow})}
                 onClick={() => this.handleFollow()}>
                {this.props.userFollowingSubmitting ? (
                    <SpinLoader className={"small"}/>
                ) : (
                    <Fragment>
                        <FontAwesomeIcon icon={faAngleDoubleRight}/>
                        {!this.state.isFollow ? 'Suivre' : 'Ne plus suivre'}
                    </Fragment>
                )}

            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userFollowingError: state.userFollowing.error,
        userFollowingLoading: state.userFollowing.loading,
        userFollowingSubmitting: state.userFollowing.submitting,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    addUserFollowing,
    removeUserFollowing,
    resetUserFollowing
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ProfileFollows);